<!--
 功能名称:千里眼平台(技师)-业绩详情
 开发人:梁高权
 创建时间:2021/04/08
 最后修改时间:2021/04/08
-->
<template>
  <div class="sellCard-wrap">
    <timeScreen :active="active" v-on:timeChange="timeChange($event)"/>
    <synchronizeTime/>
    <div class="Detail" v-show="sellCardList.length>0">
      <div class="title line">
        <span v-for="(item,index) in titleList" :key="index">{{item}}</span>
      </div>
      <ul>
        <li v-for="(item,index) in sellCardList" :key="index">
          <div class="name" @click="item.show=!item.show">
            <span>{{item.group_name}}</span>
            <van-icon :name="item.show?'arrow-up':'arrow-down'" color="#666" />
          </div>
         <div v-show="item.show" class="line" v-for="(items,indexs) in item.list" :key="indexs">
            <span>{{items.card_no}}</span>
            <span>{{items.c_num}}</span>
            <span>¥{{items.op_money}}</span>
            <span>{{items.op_type}}</span>
          </div>
        </li>
      </ul>
     <div class="sumUp">
        <span>合计</span>
        <div>
          <span>{{sumUp.num}}</span>
          <span>¥{{sumUp.money}}</span>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import table from '@/api/table'
export default {
  name: 'sellCard',
  components: {
    'timeScreen':() => import('./timeScreen'),
    'synchronizeTime':() => import('./synchronizeTime')
  },
  filters: {},
  mixins: [],
  props: {active:Number},
  data () {
    return {
      titleList:['卡类型','数量','金额','类型'],
      sellCardList:new Array(),
      sumUp:new Object()
    }
  },
  computed: {},
  watch: {},
  created () {
  },
  mounted () {

  },
  methods: {
    timeChange(val){
      if(this.active===2) this.sellCardDetail(val)
    },
    sellCardDetail(data){
      table.sellCardDetail(data).then(res=>{
        let optNum=0,opMoney=0;

        res.data.list.forEach((item,index)=>{
          item.show=true
          // if(index==0){item.show=true}else{item.show=false}
          for(let i=0;i<item.list.length;i++){
            optNum+=item.list[i].c_num
            opMoney+=item.list[i].op_money
          }
        })
        this.sumUp={num:optNum,money:opMoney}
        this.sellCardList=res.data.list
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .sellCard-wrap {
    .Detail{
      margin: 22px auto 30px;
      padding: 1px 25px 1px;
      background:#fff;
      width: 690px;
      border-radius: 16px;
      .line{
        display: flex;
        justify-content: space-between;
        align-items: center;
        span{text-align: center}
        span:nth-child(1){width: 260px;text-align:left;padding-left: 10px;}
        span:nth-child(2){flex:1;text-align:left}
        span:nth-child(3){flex:1;text-align:left}
        span:last-of-type{width: 120px;text-align: right;padding-right: 8px;}
      }
      .title{
        color: #999;
        font-size: 24px;
        margin-top: 40px;
      }
      ul{
        border-bottom: 2px solid #EAEAEA;
        padding-bottom: 55px;
        li{
          margin-top: 37px;
          .name{
            color:#333;
            font-size: 28px;
            >span{
              margin-right: 10px;
            }
          }
          .line{
            line-height: 72px;
            color: #666666;
            font-size: 28px;
          }
          .line:nth-of-type(odd){background: #F1F1F1;border-radius: 10px}
        }
      }
      .sumUp{
        display: flex;
        justify-content: space-between;
        line-height: 90px;
        >span{
          color: #333;
          font-size: 28px;
          font-weight: bold;
        }
        >div{
          width: 280px;
          display: flex;
          justify-content: space-between;
          color: #691BFF;
          font-size: 28px;
          font-weight: bold;
          span{width: 96px;text-align:center;}
        }
      }
    }
  }
</style>
